/**
 * CBLogo — official CountBucks "CB" mark.
 *
 * Renders the brand asset at /app/frontend/public/cb-logo.png — the orange C
 * + green B transparent PNG provided by the user. This is the single source
 * of truth for the logo across the app (sidebar, AI Studio header, command
 * center hero, message-bubble fallback, empty states).
 *
 * For places that need a colored variant (e.g. the green FAB where we want
 * white-on-green for contrast), pass `inverted` to render a white-tinted
 * version via CSS `brightness(0) invert(1)`.
 */

import { cn } from '../lib/utils';

const sizeMap = {
  xs: 'w-3 h-3',
  sm: 'w-4 h-4',
  md: 'w-6 h-6',
  lg: 'w-8 h-8',
  xl: 'w-10 h-10',
  '2xl': 'w-14 h-14',
};

export function CBLogo({ className, size = 'md', inverted = false }) {
  return (
    <img
      src="/cb-logo.png"
      alt="CountBucks"
      draggable={false}
      className={cn(
        sizeMap[size],
        'object-contain select-none',
        inverted && 'brightness-0 invert',
        className,
      )}
    />
  );
}
